import { memo } from 'react';

import { PrivateAssetCustomFieldValueUpdateTasksPanel } from '~/components/AssetCustomFieldValueUpdateTasks/PrivateAssetCustomFieldValueUpdateTasksPanel';
import { PrivateAssetTaggingTasksPanel } from '~/components/AssetTaggingTasks/PrivateAssetTaggingTasksPanel';
import { PrivateDeleteBoardTasksPanel } from '~/components/DeleteBoardTasks/PrivateDeleteBoardTasksPanel';
import { PrivateDeleteLibraryTasksPanel } from '~/components/DeleteLibraryTasks/PrivateDeleteLibraryTasksPanel';
import { PrivateDuplicateBoardTasksPanel } from '~/components/DuplicateBoardTasks/PrivateDuplicateBoardTasksPanel';
import { PrivateRestoreAssetTasksPanel } from '~/components/RestoreAssetTasks/PrivateRestoreAssetTasksPanel';
import { PrivateRestoreBoardTasksPanel } from '~/components/RestoreBoardTasks/PrivateRestoreBoardTasksPanel';
import { PrivateRestoreLibraryTasksPanel } from '~/components/RestoreLibraryTasks/PrivateRestoreLibraryTasksPanel';
import { PrivateVideoClipTasksPanel } from '~/components/VideoClipTasks/PrivateVideoClipTasksPanel';
import { WorkspaceActivityContainer } from '~/components/WorkspaceActivityContainer';
import { PrivateZippingTasksPanel } from '~/components/ZippingTasks/PrivateZippingTasksPanel';

export const PrivateWorkspaceActivityContainer = memo(() => {
  return (
    <WorkspaceActivityContainer>
      <PrivateVideoClipTasksPanel />
      <PrivateZippingTasksPanel />
      <PrivateAssetTaggingTasksPanel />
      <PrivateAssetCustomFieldValueUpdateTasksPanel />
      <PrivateRestoreAssetTasksPanel />
      <PrivateRestoreBoardTasksPanel />
      <PrivateRestoreLibraryTasksPanel />
      <PrivateDuplicateBoardTasksPanel />
      <PrivateDeleteBoardTasksPanel />
      <PrivateDeleteLibraryTasksPanel />
    </WorkspaceActivityContainer>
  );
});

PrivateWorkspaceActivityContainer.displayName = 'PrivateWorkspaceActivityContainer';
